/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_UpgradeInputs */

const en_home_v2_upgrade = /** @type {(inputs: Home_V2_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade`)
};

const es_home_v2_upgrade = /** @type {(inputs: Home_V2_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar plan`)
};

/**
* | output |
* | --- |
* | "Upgrade" |
*
* @param {Home_V2_UpgradeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_upgrade = /** @type {((inputs?: Home_V2_UpgradeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_UpgradeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_upgrade(inputs)
	return en_home_v2_upgrade(inputs)
});